import config from '@/config'
import helpers from '@/plugins/helpers'

const initialize = context => {
  return new Promise(async (resolve, reject) => {
    try {
      if (process.env.NODE_ENV === 'development') {
        context.commit('SET_USER', config.devUser)
      } else {
        const userProfile = await helpers.fetchApi('authentication/user', 'get')
        context.commit('SET_USER', userProfile)
        config.env === 'dev' ? console.log(userProfile) : null
      }
      resolve()
    } catch (err) {
      reject(err)
    }
  })
}

const setSnackbar = (context, data) => {
  context.commit('SET_SNACKBAR', data)
}
const setLoading = (context, data) => {
  context.commit('SET_LOADING', data)
}

export { initialize, setSnackbar, setLoading }
